import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as React from "react";
import { useFeedbackValue } from "../Contexts/FeedbackContext";
import * as Action from "../Types/ReducerTypes";
import { faTimes } from "@fortawesome/pro-light-svg-icons/faTimes";
import { CSSTransition } from 'react-transition-group';
function FeedbackDisplay() {
  var _a = useFeedbackValue(),
    state = _a[0],
    dispatch = _a[1];
  function closeMessage(message) {
    dispatch({
      type: Action.FEEDBACK_REMOVE_MESSAGE,
      message: message
    });
  }
  var messages = state.messages.map(function (item, index) {
    return /*#__PURE__*/React.createElement(CSSTransition, {
      appear: true,
      in: true,
      timeout: 500,
      classNames: 'message',
      key: index
    }, /*#__PURE__*/React.createElement("div", {
      className: "message " + item.type
    }, item.text, /*#__PURE__*/React.createElement("div", {
      className: "close",
      onClick: function () {
        return closeMessage(item);
      }
    }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faTimes
    }))));
  });
  return /*#__PURE__*/React.createElement("div", {
    id: "messageContainer"
  }, messages);
}
export default FeedbackDisplay;